import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-form-date-picker',
  templateUrl: './form-date-picker.component.html',
  styleUrls: ['./form-date-picker.component.scss']
})
export class FormDatePickerComponent implements OnInit, OnChanges {
  @Input() customLabel: boolean = false;

  @Input() disabled: boolean = false;

  @Input() inputName: string = `v6-${Math.random().toString(36).slice(2)}`;

  @Input() label: string

  @Input() helpText: string;

  @Input() model: string;

  @Input() placeholder: string;

  @Output() modelChange: EventEmitter<string> = new EventEmitter<string>();

  inputValue: string;

  constructor() { }

  ngOnInit(): void {
    this.assignFormInputValue();
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.model){
      this.assignFormInputValue();
    }
  }

  assignFormInputValue() {
    this.inputValue = this.model;
  }

  updateFormInputValue() {
    this.modelChange.emit(this.inputValue);
  }
}
